import * as React from 'react';
import { Slider } from '@mui/material';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';

const CustomSlider = styled(Slider)`
  & .MuiSlider-rail {
    background-color: ${theme.color.darkerGray};
  }

  & .MuiSlider-track {
    border: 1px solid ${theme.color.red};
    background-color: ${theme.color.red};
  }

  & .MuiSlider-thumb {
    background-color: ${theme.color.red};

    &:hover {
      box-shadow: none;
    }

    &::after {
      width: 15px;
      height: 15px;
      background-color: white;
      outline: 3px solid ${theme.color.red};
    }
  }

  & .Mui-focusVisible {
    box-shadow: none !important;
  }

  & .MuiSlider-valueLabelOpen {
    color: black;
    background-color: transparent;
    font-size: 14px;
    top: 45px;
  }
`;

interface Props {
  min: number;
  max: number;
  step: number;
  value: number;
  resolveLabel: (value: number) => string;
  onChange: (value: number) => void;
  onChangeCommitted: (value: number) => void;
  className?: string;
  testId?: string;
}

const SingleSlider = ({
  min,
  max,
  step,
  resolveLabel,
  value,
  onChange,
  onChangeCommitted,
  className,
  testId,
}: Props) => {
  const handleChange = (_: Event, value: number | number[]) => {
    if (typeof value === 'number') {
      onChange(value);
    }
  };

  const handleChangeCommitted = (_: React.SyntheticEvent | Event, value: number | number[]) => {
    if (typeof value === 'number') {
      onChangeCommitted(value);
    }
  };

  return (
    <CustomSlider
      className={className}
      data-testid={testId}
      min={min}
      max={max}
      step={step}
      value={value}
      valueLabelDisplay='on'
      valueLabelFormat={resolveLabel}
      onChange={handleChange}
      onChangeCommitted={handleChangeCommitted}
    />
  );
};

export default SingleSlider;
